<div class="modal-header modalHeaderBlack">
    <h6 class="modal-title"> Patient History</h6>
    <span aria-label="Close" class="close" (click)="close()" data-automation-attribute="span-close-dialog">
        <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}">clear</mat-icon>
    </span>
</div>

<div class="modal-body">


    <!-- Patient Info -->
    <div *ngIf="historyData" class="selected-patient">

        <span>{{ historyData.mrn }}</span> /
        <span>{{ historyData.patientName }}</span> /
        <span>{{ historyData.dateOfBirth | date:'dd/MM/yyyy' }}</span>
        <span>({{ historyData.age }} Years)</span>

    </div>

    <!-- Appointments -->
    <mat-tab-group class="tabGroupPersonalDetails mt-10">

        <!-- Appointment History Tab -->
        <mat-tab label="Appointment History">

            <div class="table-container scroll-table">

                <table mat-table [dataSource]="appointmentDataSource" class="mat-elevation-z8">

                    <!-- Date -->
                    <ng-container matColumnDef="appointmentDate">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.appointmentDate | date:'dd/MM/yyyy' }}
                        </td>
                    </ng-container>

                    <!-- Department -->
                    <ng-container matColumnDef="department">
                        <th mat-header-cell *matHeaderCellDef>Department</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.department }}
                        </td>
                    </ng-container>

                    <!-- Doctor -->
                    <ng-container matColumnDef="doctor">
                        <th mat-header-cell *matHeaderCellDef>Doctor</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.doctor }}
                        </td>
                    </ng-container>

                    <!-- Type -->
                    <ng-container matColumnDef="appointmentType">
                        <th mat-header-cell *matHeaderCellDef>Type</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.appointmentType }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="teleconsultationType">
                        <th mat-header-cell *matHeaderCellDef>Teleconsultation Type</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.teleconsultationType || '-' }}
                        </td>
                    </ng-container>
                    <!-- Category -->
                    <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef>Category</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.category }}
                        </td>
                    </ng-container>

                    <!-- Rows -->
                    <tr mat-header-row *matHeaderRowDef="appointmentColumns sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: appointmentColumns"></tr>

                </table>

                <!-- No Data -->
                <div class="center" *ngIf="appointmentDataSource.data.length === 0">
                    No Appointment History
                </div>

            </div>

        </mat-tab>

    </mat-tab-group>

    <!-- Medications -->
    <mat-tab-group class="tabGroupPersonalDetails mt-20">

        <mat-tab label="Medication History">

            <div class="table-container  scroll-table">

                <table mat-table [dataSource]="medicationDataSource" class="mat-elevation-z8">

                    <!-- Date -->
                    <ng-container matColumnDef="medicationDate">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.medicationDate | date:'dd/MM/yyyy' }}
                        </td>
                    </ng-container>

                    <!-- Drug -->
                    <ng-container matColumnDef="drugName">
                        <th mat-header-cell *matHeaderCellDef>Drug Name</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.drugName }}
                        </td>
                    </ng-container>

                    <!-- Quantity -->
                    <ng-container matColumnDef="quantity">
                        <th mat-header-cell *matHeaderCellDef>Qty</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.quantity }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="drugLable">
                        <th mat-header-cell *matHeaderCellDef>Drug Label</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.frequency || '-' }}
                        </td>
                    </ng-container>
                    <!-- Doctor -->
                    <ng-container matColumnDef="doctor">
                        <th mat-header-cell *matHeaderCellDef>Doctor</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.doctor }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="route">
                        <th mat-header-cell *matHeaderCellDef>Route</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.route || '-' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="uomUnit">
                        <th mat-header-cell *matHeaderCellDef>Unit</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.uomUnit || '-' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="instruction">
                        <th mat-header-cell *matHeaderCellDef>Instruction</th>
                        <td mat-cell *matCellDef="let element" class="wrap-text">
                            {{ element.instruction || '-' }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="medicationColumns sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: medicationColumns"></tr>

                </table>

            </div>

            <div class="center" *ngIf="medicationDataSource.data.length === 0">
                No Medication History
            </div>

        </mat-tab>

    </mat-tab-group>

</div>